import type { FC } from 'react'

import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'

export const GridBackground: FC = () => {
  return <Box sx={gridSx} />
}

const gridSx: SxProps<Theme> = (theme) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  backgroundColor: 'background.default',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? `linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
         linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px)`
      : `linear-gradient(rgba(62, 39, 35, 0.04) 1px, transparent 1px),
         linear-gradient(90deg, rgba(62, 39, 35, 0.04) 1px, transparent 1px)`,
  backgroundSize: '40px 40px',
  pointerEvents: 'none',
})
